import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type Guest, type GuestBulkResult } from '../api/client';

export function useGuests(eventId: string | undefined) {
  return useQuery<Guest[]>({
    queryKey: ['guests', eventId],
    queryFn: () => api.guests.list(eventId!),
    enabled: !!eventId,
  });
}

export function useAddGuests() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { eventId: string; guests: Array<{ email: string; name: string }> }) =>
      api.guests.add(data.eventId, data.guests),
    onSuccess: (_result: GuestBulkResult, variables) => {
      queryClient.invalidateQueries({ queryKey: ['guests', variables.eventId] });
      queryClient.invalidateQueries({ queryKey: ['event', variables.eventId] });
    },
  });
}
